<template>
    <div class="vehicle-specs">
      <div class="vehicle-specs__container">
        <div class="vehicle-specs__info" v-for="(item, index) in vehicleSpecs" :key="index">
          <div
            :class="`vehicle-specs__icon touchpoint__icon--${item.value.toString().toLowerCase()}`"> </div>
          <div> {{ item.key }} {{ item.value }} </div>
        </div>
        <div class="vehicle-specs__info" v-if="showColourSpecs">
          <div
          :class="`vehicle-specs__icon vehicle-specs__icon--colour colour-touchpoint__colour--${classColour}`"> </div>
          <div class="vehicle-specs__text"> {{ colourLabel }} </div>
        </div>
      </div>
    </div>
</template>

<script lang='ts'>
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';
import {
  State, Getter, Action, Mutation, namespace
} from 'vuex-class';
import KeyValue from '../../models/KeyValue';
import SearchQuery from '../../models/SearchQuery';
import IDerivative from '../../models/vehicle/interfaces/derivative.d';

const SearchQueryModule = namespace('searchQueryModule');

@Component
export default class VehicleSpecsComponent extends Vue {
    @SearchQueryModule.Getter public searchQuery;

    @Prop({ default: false })
    public showDoorSpecs!: boolean;

    @Prop({ default: false })
    public showColourSpecs!: boolean;

    public vehicleSpecsArray: KeyValue[] = [];

    public get vehicleSpecs(): KeyValue[] {
      return this.vehicleSpecsArray;
    }

    public set vehicleSpecs(specs: KeyValue[]) {
      this.vehicleSpecsArray = specs;
    }

    public get classColour(): string {
      return this.searchQuery.basicColour ? this.searchQuery.basicColour.replace(/\s+|[/]/g, '').toLowerCase() : 'notsureother';
    }

    public get colourLabel(): string {
      return this.classColour === 'notsureother' || this.classColour.length <= 0 ? 'Colour unspecified' : this.searchQuery.basicColour;
    }

    public get currentDerivative(): IDerivative | null {
      return this.$store.getters['vehicleModule/currentDerivative'];
    }

    public get transmission(): string {
      if (this.currentDerivative) {
        return this.currentDerivative.transmissionName;
      }
      return '';
    }

    public get fuelType(): string {
      if (this.currentDerivative) {
        return this.currentDerivative.fuelTypeName;
      }
      return '';
    }

    public get doors(): string {
      if (this.currentDerivative) {
        return `${this.currentDerivative.doors}`;
      }
      return '';
    }

    @Watch('currentDerivative')
    public createSpecs() {
      if (this.transmission && this.fuelType) {
        if (this.showDoorSpecs && this.doors) {
          this.vehicleSpecs = [
            new KeyValue('', this.transmission),
            new KeyValue('', this.fuelType),
            new KeyValue(this.searchQuery.doors, 'Doors')
          ];
        }

        this.vehicleSpecs = [
          new KeyValue('', this.transmission),
          new KeyValue('', this.fuelType)
        ];
      }
    }
}
</script>
